import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function HowItWorks() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const phases = [{
    number: '1',
    title: 'Fase de Extinción',
    description: 'Eliminamos los "secuestradores" de glucosa que generan la niebla inmediata.'
  }, {
    number: '2',
    title: 'Fase de Activación',
    description: 'Introducimos las grasas estructurales que tu cerebro necesita para reconstruir su conexión.'
  }, {
    number: '3',
    title: 'Fase de Blindaje',
    description: 'Implementamos micro-hábitos de manejo de cortisol para que el enfoque sea permanente.'
  }];
  return <section ref={ref} className="w-full bg-white py-16 md:py-20" data-id="element-118">
      <div className="max-w-5xl mx-auto px-6" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.7
      }} data-id="element-120">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-teal-900" data-id="element-121">
            Cómo Funciona
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-122">
            {phases.map((phase, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="relative" data-id="element-123">
                <div className="bg-cream p-8 rounded-lg h-full" data-id="element-124">
                  <div className="w-16 h-16 bg-amber-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mb-6 mx-auto" data-id="element-125">
                    {phase.number}
                  </div>
                  <h3 className="text-xl font-bold text-teal-900 mb-4 text-center" data-id="element-126">
                    {phase.title}
                  </h3>
                  <p className="text-gray-700 text-center leading-relaxed" data-id="element-127">
                    {phase.description}
                  </p>
                </div>

                {index < phases.length - 1 && <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2" data-id="element-128">
                    <svg className="w-8 h-8 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-129">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-130" />
                    </svg>
                  </div>}
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}